<template>
  <div class="bg-grey-main flex flex-wrap px-4 py-4">
    <div class="mb-4 flex items-center justify-between gap-2">
      <h3 class="dolphin-bold mb-0 flex w-full items-center gap-3">
        <UtilsIcon
          name="CloseCircleFull.svg"
          color="negative-main"
          class="inline-block h-6 w-6"
          fetch-priority="high"
          :preload="true"
        />
        {{ $t("productPage.purchaseType.notAvailable.title") }}
      </h3>
    </div>
    <p class="beaver markdown__strong-beaver-bold w-full" :class="'mb-5'">
      {{
        $t("productPage.purchaseType.notAvailable.descriptionBeforeSubmitting")
      }}
    </p>

    <SkeletonAnimatedPlaceholder
      class="mb-5"
      height="38px"
      width="100%"
      borderRadius="0.25rem"
    />

    <UtilsButton
      :text="$t('dialogsAndModals.productNotAvailable.privacy')"
      target="_blank"
      :path="`/privacy`"
      class="custom-btn-no-padding custom-btn-mouse-medium mb-5"
      theme="link-green"
      disabled
    />

    <SkeletonAnimatedPlaceholder height="34px" width="100%" />
  </div>
</template>
